import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../services/api';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './login.html',
  styleUrls: ['./login.scss']
})
export class LoginComponent implements OnInit {
  userIdOrEmail = '';
  password = '';
  isLoading = false;
  isRegistering = false;
  errorMessage = '';
  showRegister = false;

  selectedCountryCode = '+91';
  showCountryDropdown = false;

  getSelectedCountry() {
    return this.countryCodes.find(c => c.dial === this.selectedCountryCode) || this.countryCodes[0];
  }

  selectCountry(dial: string) {
    this.selectedCountryCode = dial;
    this.showCountryDropdown = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.showCountryDropdown && !this.elRef.nativeElement.querySelector('.country-dropdown')?.contains(event.target as Node)) {
      this.showCountryDropdown = false;
    }
  }


  countryCodes = [
    { flag: '🇦🇫', name: 'Afghanistan', dial: '+93' },
    { flag: '🇦🇱', name: 'Albania', dial: '+355' },
    { flag: '🇩🇿', name: 'Algeria', dial: '+213' },
    { flag: '🇦🇷', name: 'Argentina', dial: '+54' },
    { flag: '🇦🇲', name: 'Armenia', dial: '+374' },
    { flag: '🇦🇺', name: 'Australia', dial: '+61' },
    { flag: '🇦🇹', name: 'Austria', dial: '+43' },
    { flag: '🇦🇿', name: 'Azerbaijan', dial: '+994' },
    { flag: '🇧🇭', name: 'Bahrain', dial: '+973' },
    { flag: '🇧🇩', name: 'Bangladesh', dial: '+880' },
    { flag: '🇧🇪', name: 'Belgium', dial: '+32' },
    { flag: '🇧🇷', name: 'Brazil', dial: '+55' },
    { flag: '🇨🇦', name: 'Canada', dial: '+1' },
    { flag: '🇨🇱', name: 'Chile', dial: '+56' },
    { flag: '🇨🇳', name: 'China', dial: '+86' },
    { flag: '🇨🇴', name: 'Colombia', dial: '+57' },
    { flag: '🇨🇾', name: 'Cyprus', dial: '+357' },
    { flag: '🇨🇿', name: 'Czech Republic', dial: '+420' },
    { flag: '🇩🇰', name: 'Denmark', dial: '+45' },
    { flag: '🇪🇬', name: 'Egypt', dial: '+20' },
    { flag: '🇪🇪', name: 'Estonia', dial: '+372' },
    { flag: '🇪🇹', name: 'Ethiopia', dial: '+251' },
    { flag: '🇫🇮', name: 'Finland', dial: '+358' },
    { flag: '🇫🇷', name: 'France', dial: '+33' },
    { flag: '🇬🇪', name: 'Georgia', dial: '+995' },
    { flag: '🇩🇪', name: 'Germany', dial: '+49' },
    { flag: '🇬🇭', name: 'Ghana', dial: '+233' },
    { flag: '🇬🇷', name: 'Greece', dial: '+30' },
    { flag: '🇭🇰', name: 'Hong Kong', dial: '+852' },
    { flag: '🇭🇺', name: 'Hungary', dial: '+36' },
    { flag: '🇮🇳', name: 'India', dial: '+91' },
    { flag: '🇮🇩', name: 'Indonesia', dial: '+62' },
    { flag: '🇮🇷', name: 'Iran', dial: '+98' },
    { flag: '🇮🇶', name: 'Iraq', dial: '+964' },
    { flag: '🇮🇪', name: 'Ireland', dial: '+353' },
    { flag: '🇮🇱', name: 'Israel', dial: '+972' },
    { flag: '🇮🇹', name: 'Italy', dial: '+39' },
    { flag: '🇯🇵', name: 'Japan', dial: '+81' },
    { flag: '🇯🇴', name: 'Jordan', dial: '+962' },
    { flag: '🇰🇿', name: 'Kazakhstan', dial: '+7' },
    { flag: '🇰🇪', name: 'Kenya', dial: '+254' },
    { flag: '🇰🇼', name: 'Kuwait', dial: '+965' },
    { flag: '🇱🇧', name: 'Lebanon', dial: '+961' },
    { flag: '🇲🇾', name: 'Malaysia', dial: '+60' },
    { flag: '🇲🇻', name: 'Maldives', dial: '+960' },
    { flag: '🇲🇽', name: 'Mexico', dial: '+52' },
    { flag: '🇲🇦', name: 'Morocco', dial: '+212' },
    { flag: '🇳🇱', name: 'Netherlands', dial: '+31' },
    { flag: '🇳🇿', name: 'New Zealand', dial: '+64' },
    { flag: '🇳🇬', name: 'Nigeria', dial: '+234' },
    { flag: '🇳🇴', name: 'Norway', dial: '+47' },
    { flag: '🇴🇲', name: 'Oman', dial: '+968' },
    { flag: '🇵🇰', name: 'Pakistan', dial: '+92' },
    { flag: '🇵🇭', name: 'Philippines', dial: '+63' },
    { flag: '🇵🇱', name: 'Poland', dial: '+48' },
    { flag: '🇵🇹', name: 'Portugal', dial: '+351' },
    { flag: '🇶🇦', name: 'Qatar', dial: '+974' },
    { flag: '🇷🇴', name: 'Romania', dial: '+40' },
    { flag: '🇷🇺', name: 'Russia', dial: '+7' },
    { flag: '🇸🇦', name: 'Saudi Arabia', dial: '+966' },
    { flag: '🇸🇬', name: 'Singapore', dial: '+65' },
    { flag: '🇿🇦', name: 'South Africa', dial: '+27' },
    { flag: '🇰🇷', name: 'South Korea', dial: '+82' },
    { flag: '🇪🇸', name: 'Spain', dial: '+34' },
    { flag: '🇱🇰', name: 'Sri Lanka', dial: '+94' },
    { flag: '🇸🇪', name: 'Sweden', dial: '+46' },
    { flag: '🇨🇭', name: 'Switzerland', dial: '+41' },
    { flag: '🇹🇼', name: 'Taiwan', dial: '+886' },
    { flag: '🇹🇿', name: 'Tanzania', dial: '+255' },
    { flag: '🇹🇭', name: 'Thailand', dial: '+66' },
    { flag: '🇹🇷', name: 'Turkey', dial: '+90' },
    { flag: '🇦🇪', name: 'UAE', dial: '+971' },
    { flag: '🇺🇬', name: 'Uganda', dial: '+256' },
    { flag: '🇺🇦', name: 'Ukraine', dial: '+380' },
    { flag: '🇬🇧', name: 'United Kingdom', dial: '+44' },
    { flag: '🇺🇸', name: 'United States', dial: '+1' },
    { flag: '🇺🇿', name: 'Uzbekistan', dial: '+998' },
    { flag: '🇻🇳', name: 'Vietnam', dial: '+84' },
    { flag: '🇾🇪', name: 'Yemen', dial: '+967' },
    { flag: '🇿🇲', name: 'Zambia', dial: '+260' },
    { flag: '🇿🇼', name: 'Zimbabwe', dial: '+263' },
  ];

  registerData = {
    userId: '',
    fullName: '',
    email: '',
    phoneNumber: '',
    password: ''
  };

  private setAuthData(token: string, user: any) {
    localStorage.setItem('auth_token', token);
    localStorage.setItem('userData', JSON.stringify(user));
  }

  constructor(private router: Router, private apiService: ApiService, private route: ActivatedRoute, private elRef: ElementRef) { }

  ngOnInit() {
    // Check if register query parameter is present
    this.route.queryParams.subscribe(params => {
      if (params['register'] === 'true') {
        this.showRegister = true;
      }
    });
  }

  login() {
    if (this.isLoading) return;

    this.isLoading = true;
    this.errorMessage = '';

    // Login request initiated

    this.apiService.login(this.userIdOrEmail, this.password)
      .subscribe({
        next: (response) => {
          if (response.success && response.data) {
            this.setAuthData(response.data.token, response.data.user);
            window.location.href = '/dashboard';
            return;
          } else {
            this.errorMessage = response.error || 'Login failed';
          }
          this.isLoading = false;
        },
        error: (error) => {
          // Extract the most specific error message from the backend
          if (error.status === 0) {
            // Network error - no response from server
            this.errorMessage = 'Unable to connect to server. Please check your internet connection.';
          } else if (error.status === 429) {
            this.errorMessage = 'Too many failed attempts. Please try again after a few minutes.';
          } else if (error.error?.error) {
            // Backend returned a specific error message
            this.errorMessage = error.error.error;
          } else {
            this.errorMessage = 'Login failed. Please try again.';
          }
          this.isLoading = false;
        }
      });
  }

  register() {
    this.isRegistering = true;
    this.errorMessage = '';

    // Validate required fields
    if (!this.registerData.userId || !this.registerData.fullName || !this.registerData.email || !this.registerData.phoneNumber || !this.registerData.password) {
      this.errorMessage = 'All fields are required';
      this.isRegistering = false;
      return;
    }

    // Prepend country code to phone number with space
    const fullPhone = this.selectedCountryCode + ' ' + this.registerData.phoneNumber;



    // Registration request initiated

    this.apiService.register(this.registerData.userId, this.registerData.fullName, this.registerData.password, this.registerData.email, fullPhone)
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.setAuthData(response.data.token, response.data.user);
            // Trigger storage event for navbar update
            window.dispatchEvent(new Event('storage'));
            window.location.href = '/dashboard';
          } else {
            this.errorMessage = response.error || 'Registration failed';
          }
          this.isRegistering = false;
        },
        error: (error) => {
          this.errorMessage = error.error?.error || 'Registration failed. Please try again.';
          this.isRegistering = false;
        }
      });
  }

  toggleRegister() {
    this.showRegister = !this.showRegister;
    this.errorMessage = '';
    this.resetForms();
  }

  private resetForms() {
    this.userIdOrEmail = '';
    this.password = '';
    this.selectedCountryCode = '+91';
    this.showCountryDropdown = false;
    this.registerData = {
      userId: '',
      fullName: '',
      email: '',
      phoneNumber: '',
      password: ''
    };
  }
}
